// extracted by mini-css-extract-plugin
export default {"departmentsPanel":"DepartmentsPanel-module__departmentsPanel__tB7nG"};